export const initialAnalyser = {
  mode: "explore", // string "explore" or "edit". In "explore" modus, the user can add different types of moodboards. In "edit" modus, the user only can edit one specific board.
  openSurveysAndLabels: true,
  openMoodboards: false,
};
export default function analyserReducer(analyser, action) {
  switch (action.type) {
    case "TOGGLE_SURVEYS":
      return {
        ...analyser,
        openSurveysAndLabels: !analyser.openSurveysAndLabels,
      };

    /*   case "OPEN_MOODBOARDS":
      return { ...analyser, openMoodboards: true };

    case "TOGGLE_MOODBOARDS":
      return { ...analyser, openMoodboards: !analyser.openMoodboards };
 */
    case "SET_EDIT":
      return { ...analyser, mode: "edit" };

    case "SET_EXPLORE":
      return { ...analyser, mode: "explore" };

    default:
      return analyser;
  }
}
